import { createDecorator } from '../../instantiation/common/instantiation.js';
const ISecretStorageService = ( createDecorator('secretStorageService'));
export { ISecretStorageService };
